window.stripeCalculation = function (billing_surcharge,stripe_fee,stripe_cent,gst_fee,is_gst,amount) {

    let processing_stripe_fee = roundTo(parseInt(amount,10) * (stripe_fee) + (stripe_cent),2);
    let processing_giftit_fee = parseFloat(billing_surcharge);
    let processing_fee = roundTo(parseFloat(processing_stripe_fee) + parseFloat(processing_giftit_fee),2);
    let gst = (is_gst === 1)? roundTo(parseFloat(processing_fee) * gst_fee,2) : 0;

    let total = roundTo(parseFloat(amount) + parseFloat(processing_fee) + parseFloat(gst),2);
    // console.log({
    //     processing_stripe_fee:processing_stripe_fee,
    //     processing_giftit_fee:processing_giftit_fee,
    //     processing_fee:processing_fee,
    //     gst:gst,
    // });

    return total;
}

window.stripeCalculationAPI = function (merchant_id, amount, input) {
    const apiURL = '/api/stripe_calculation'
    const data = {
        merchant_id: merchant_id,
        amount: amount
    }

    // Tag this call with a request id on the target input so that if the user
    // keeps typing and fires several calls in a row, an older response can't
    // land after a newer one and overwrite the total with a stale value.
    const requestId = (input._stripeCalcRequestId = (input._stripeCalcRequestId || 0) + 1);

    fetch(apiURL, {
        method: 'POST', // Specify the method
        headers: {
            'Content-Type': 'application/json', // Inform the server the body format
        },
        body: JSON.stringify(data), // Convert the JavaScript object to a JSON string
    })
    .then(response => {
        // Check if the request was successful (status in the 200 range)
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json(); // Parse the JSON response body
    })
    .then(responseData => {
        if (input._stripeCalcRequestId === requestId) {
            // always show 2 decimal places (e.g. 104.40, not 104.4)
            input.value = Number(responseData.total).toFixed(2)
            // let the page refresh anything derived from the total (e.g. the Platform Charge label)
            input.dispatchEvent(new CustomEvent('stripe-total-updated', { detail: { total: Number(responseData.total) } }))
        }
    })
    .catch((error) => {
        console.error('Error:', error); // Handle network errors or non-ok responses
    });
}

window.stripeEventCalculation = function (billing_surcharge,stripe_fee,stripe_cent,gst_fee,is_gst,amount) {

    let processing_stripe_fee = roundTo(parseInt(amount,10) * (stripe_fee) + (stripe_cent),2);
    let processing_giftit_fee = parseFloat(billing_surcharge);
    let processing_fee = roundTo(parseFloat(processing_stripe_fee) + parseFloat(processing_giftit_fee),2);
    let gst = (is_gst === 1)? roundTo(parseFloat(processing_fee) * gst_fee,2) : 0;

    let total = roundTo(parseInt(amount,10) + parseFloat(processing_fee) + parseFloat(gst),2);
    // console.log({
    //     processing_stripe_fee:processing_stripe_fee,
    //     processing_giftit_fee:processing_giftit_fee,
    //     processing_fee:processing_fee,
    //     gst:gst,
    // });

    return total;
}

function roundTo(n, digits) {
    if (digits === undefined) {
        digits = 0;
    }

    var multiplicator = Math.pow(10, digits);
    n = parseFloat((n * multiplicator).toFixed(11));
    var test =(Math.round(n) / multiplicator);
    return +(test.toFixed(digits));
}


// WEBPACK FOOTER //
// ./resources/assets/website/scripts/stripeCalculation.js